import { render, staticRenderFns } from "./EditStagingElektronik.vue?vue&type=template&id=c22d046a&"
import script from "./EditStagingElektronik.vue?vue&type=script&lang=js&"
export * from "./EditStagingElektronik.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports